import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { NotificationFilterEnum } from '../../enums/notification';
import {
  NotificationPreferenceType,
  NotificationPreferenceUpdate,
  NotificationRead,
} from '../../models/notification';
import {
  AssignedVehicleParams,
  JobParams,
  LoadParams,
  NewShipperSignupParams,
  PaymentParams,
  QuoteParams,
} from '../../models/push-notification';

export const notificationEvents = eventGroup({
  source: 'Notification',
  events: {
    clear: type<void>(),
    setLoading: type<boolean>(),
    loadNotifications: type<{
      filter: NotificationFilterEnum;
      limit: number;
      showLoading: boolean;
    }>(),
    loadedNotifications: type<{
      notifications: NotificationRead[];
      totalNotifications: number;
      unreadNotifications: number;
    }>(),
    markNotificationRead: type<{
      ids: string[];
    }>(),
    markedNotificationsRead: type<{
      ids: string[];
    }>(),
    loadNotificationPreferences: type<{
      pageSize: number;
      page: number;
    }>(),
    loadedNotificationPreferences: type<{
      notificationPreferences: NotificationPreferenceType | null;
    }>(),
    updatePreference: type<NotificationPreferenceUpdate>(),

    navigateToJob: type<JobParams | null>(),
    navigateToLoad: type<LoadParams | null>(),
    navigateToQuote: type<QuoteParams | null>(),
    navigateToShipperDetail: type<NewShipperSignupParams | null>(),
    navigateToPayment: type<PaymentParams | null>(),
    navigateToExpiredJob: type<JobParams | null>(),
    navigateToTrackLoads: type<AssignedVehicleParams | null>(),
    clearNavigationTargets: type<void>(),
  },
});
